export default __webpack_public_path__ + "static/media/portada10.9ae0d5b4.jpg";